import { render, staticRenderFns } from "./mecCouchList.vue?vue&type=template&id=928fb1a6&"
import script from "./mecCouchList.vue?vue&type=script&lang=js&"
export * from "./mecCouchList.vue?vue&type=script&lang=js&"
import style0 from "./mecCouchList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports